import { render, staticRenderFns } from "./DashboardPageShimmer.vue?vue&type=template&id=c120c2a6&scoped=true&"
import script from "./DashboardPageShimmer.vue?vue&type=script&lang=js&"
export * from "./DashboardPageShimmer.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPageShimmer.vue?vue&type=style&index=0&id=c120c2a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c120c2a6",
  null
  
)

export default component.exports